import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import CommitteesELe from './Committees'


function Main() {
    return (
      <>
          <Header/>
        <Breadcrumb title="Home" subtitle="Committees"/>
        <CommitteesELe />
      </>
    )
  }
  
  export default Main